import React from 'react';
import { Container } from 'react-bootstrap';

import Header from '../../../components/Header';
import Stepper from '../../../components/Stepper';
import Summary from './components/Summary';

const SummaryContainer = () => {
  return (
    <React.Fragment>
      <Header />
      <Container fluid className="dap_no-padding">
        <Stepper />
        <Summary />
   
      </Container>
    </React.Fragment>
  );
};

export default SummaryContainer;
